module.exports = __webpack_public_path__ + "static/img/Monkey.e39ad8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Monkey.svg
// module id = 1362
// module chunks = 0